/** Whether each field a phone's caller line can show has text. */
export interface CallerFields {
  title: boolean;
  subtitle: boolean;
}

/**
 * Learners see a phone's title as the caller, or its subtitle when it has no
 * title.
 */
export const callerFieldOf = ({
  title,
  subtitle
}: CallerFields): keyof CallerFields =>
  !title && subtitle ? 'subtitle' : 'title';

/** The editor's cue for an empty caller line, whichever field holds it. */
export const CALLER_NAME_HINT = 'Add caller name';
